import React from 'react';
import { IconButton, ListItem, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { StockCard } from '../../../types';

interface StockCardOptionProps {
    stockCard: StockCard;
    onAdd(): void;
    onRemove(): void;
    isPicked?: boolean;
}

const StockCardOption = ({ stockCard, onAdd, isPicked, onRemove }: StockCardOptionProps) => {
    const { name, conversionUnit, convertedAmount, storageUnit } = stockCard;
    let postfix = storageUnit.toString();
    if (conversionUnit && convertedAmount) {
        postfix = `${convertedAmount} ${conversionUnit}`;
    }

    return (
        <ListItem
            button
            onClick={onAdd}
            disabled={isPicked}
        >
            <ListItemText primary={name} secondary={postfix} />
            {isPicked ? (
                <ListItemSecondaryAction>
                    <IconButton onClick={onRemove} edge="end" aria-label="delete">
                        <DeleteIcon />
                    </IconButton>
                </ListItemSecondaryAction>
            ): null}
        </ListItem>
    );
};

export default StockCardOption;
